import {useSearchParams} from 'react-router-dom';
import {Tabs, TabsList, TabsTrigger, TabsContent} from '@common-web/components/ui/tabs';
import {ShieldCheck} from 'lucide-react';
import {PageHeader} from '@common-web/components/page-header';
import {RolesList} from '@internal/pages/roles/RolesList';
import {PermissionsList} from '@internal/pages/permissions/PermissionsList';
import {FeatureRequirementsList} from '@internal/pages/permissions/FeatureRequirementsList';

type TabKey = 'roles' | 'permissions' | 'features';

function resolveTab(value: string | null): TabKey {
  return value === 'permissions' || value === 'features' ? value : 'roles';
}

export function RolesAndPermissions() {
  const [params, setParams] = useSearchParams();
  const tab = resolveTab(params.get('tab'));

  return (
    <div className='min-h-screen bg-gradient-to-br from-gray-50 via-white to-brand-blue/5'>
      <PageHeader
        title='Roles & Permissions'
        description='Manage roles, choose the permissions each role grants, and review the underlying permission catalog.'
        icon={<ShieldCheck className='h-6 w-6' />}
      />

      <div className='px-8 pt-6 max-w-7xl mx-auto w-full'>
        <Tabs value={tab} onValueChange={(value) => setParams({tab: value}, {replace: true})}>
          <TabsList>
            <TabsTrigger value='roles'>Roles</TabsTrigger>
            <TabsTrigger value='permissions'>Permissions</TabsTrigger>
            <TabsTrigger value='features'>Features</TabsTrigger>
          </TabsList>
          <TabsContent value='roles'>
            <RolesList embedded />
          </TabsContent>
          <TabsContent value='permissions'>
            <PermissionsList embedded />
          </TabsContent>
          <TabsContent value='features'>
            <FeatureRequirementsList />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
